<template>
  <svg
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    viewBox="0 0 24 24"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle
      cx="8.5"
      cy="7"
      r="4"
    />
    <line
      x1="20"
      y1="8"
      x2="20"
      y2="14"
    />
    <line
      x1="23"
      y1="11"
      x2="17"
      y2="11"
    />
  </svg>
</template>

<script>
export default {
  name: "RegisterIcon",
  props: {
    size: { type: Number, default: 14 },
  },
};
</script>
